import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface MetricData {
  id: number;
  label: string;
  value: string;
  change: string;
  trend: 'up' | 'down';
  icon: string;
  description: string;
}

const mockMetrics: MetricData[] = [
  {
    id: 1,
    label: 'Global Participants',
    value: '18.4K',
    change: '+18.5%',
    trend: 'up',
    icon: 'UsersIcon',
    description: 'Active participants worldwide in 2026'
  },
  {
    id: 2,
    label: 'Communities Transformed',
    value: '127',
    change: '+24.3%',
    trend: 'up',
    icon: 'HomeModernIcon',
    description: 'Local chapters and community groups'
  },
  {
    id: 3,
    label: 'Conflict Reduction',
    value: '42%',
    change: '+12.1%',
    trend: 'up',
    icon: 'ShieldCheckIcon',
    description: 'Measured decrease in community conflicts'
  },
  {
    id: 4,
    label: 'Humanitarian Aid',
    value: '$780K',
    change: '+31.7%',
    trend: 'up',
    icon: 'HeartIcon',
    description: 'Direct support to vulnerable populations'
  }
];

const ImpactMetrics = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {mockMetrics.map((metric) => (
        <div
          key={metric.id}
          className="bg-card rounded-lg p-6 shadow-md hover:shadow-lg transition-all duration-300 border border-border"
        >
          <div className="flex items-start justify-between mb-4">
            <div className="p-3 bg-primary/10 rounded-lg">
              <Icon name={metric.icon as any} size={24} className="text-primary" />
            </div>
            <div
              className={`flex items-center space-x-1 px-2 py-1 rounded-full text-xs font-semibold ${
                metric.trend === 'up' ?'bg-success/10 text-success' :'bg-error/10 text-error'
              }`}
            >
              <Icon
                name={metric.trend === 'up' ? 'ArrowTrendingUpIcon' : 'ArrowTrendingDownIcon'}
                size={14}
              />
              <span>{metric.change}</span>
            </div>
          </div>
          <div className="space-y-2">
            <h3 className="text-3xl font-headline font-bold text-foreground">{metric.value}</h3>
            <p className="text-sm font-body font-semibold text-foreground">{metric.label}</p>
            <p className="text-xs font-body text-muted-foreground">{metric.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ImpactMetrics;